import { ChangeEvent } from 'react';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { IRadioControlledProps as IProps } from './types';

export const RadioControlled = <T extends FieldValues>(props: UseControllerProps<T> & IProps) => {
  const {
    name,
    control,
    rules,
    defaultValue,
    options,
    radioControlledStyles,
    disabled = false,
    onChange: onChangeProps,
    ...restProps
  } = props;

  const { field } = useController({
    name,
    control,
    rules,
    defaultValue,
  });
  const { value, onChange, ...restField } = field;

  const handleChange = (event: ChangeEvent<HTMLInputElement>, value: string) => {
    onChange(event, value);
    if (onChangeProps) {
      onChangeProps(event, value);
    }
  };

  return (
    <FormControl>
      <RadioGroup
        row
        value={Array.isArray(value) && value.length > 0 ? value[0]?.value : (value ?? '')}
        {...restField}
        {...restProps}
        onChange={handleChange}
        sx={{
          '.MuiTypography-root': {
            fontSize: '14px!important',
          },
          ...restProps.sx,
        }}
      >
        {options.map((item) => (
          <FormControlLabel
            className={radioControlledStyles?.radioLabel}
            key={item.value}
            value={item.value}
            control={<Radio />}
            label={item.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
